import React from 'react';

export var StopIcon = function StopIcon(props) {
  return React.createElement(
    "svg",
    {
      "data-qa": "StopIcon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      height: "100%",
      preserveAspectRatio: "none",
      viewBox: "0 0 1060 1060"
    },
    React.createElement("circle", { fill: props.circleColor, cx: "530", cy: "530", r: "512" }),
    React.createElement("rect", { fill: props.iconColor, x: "340", y: "340", width: "380", height: "380" })
  );
};